// Import Routes
import * as ROUTES from "../routes";

import APPSETTINGS from '@/modules/appManager/views/settings'
import APPNOTIFICATIONS from '@/modules/appManager/views/notifications'

const routes = [
    {
        path: ROUTES.APPSETTINGS,
        name: "appSettings",
        component: APPSETTINGS,
        meta: {
            title: "Manage Client Application",
            layout: "private",
            requiresAuth: true,
            nav: 'App Manager',
            permissions: ['can_view_system_settings']
        }
    },
    {
        path: ROUTES.APPNOTIFICATIONS,
        name: "appNotification",
        component: APPNOTIFICATIONS,
        meta: {
            title: "App Notifications",
            layout: "private",
            requiresAuth: true,
            nav: 'App Manager',
            permissions: ['can_view_notifications']
        }
    },
]

export default routes;
